<template>
  <div>
    <v-container container--fluid>
      <v-row class="px-4">
        <h1>Manage Permissions Groups</h1>
      </v-row>
      <v-row :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'space-between'">
        <v-col cols="9" sm="9" md="3">
          <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
        </v-col>
        <div style="display: flex; justify-content: center; align-items: center">
          <v-btn text @click="refresh" v-if="!isVisible">
            <v-icon color="cyan darken-2">refresh</v-icon>
          </v-btn>
          <div v-if="isVisible" class="load-3">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
        </div>
        <v-col cols="4" sm="4" md="2" class="text-center" v-if="$vuetify.breakpoint.mdAndUp">
          <v-tooltip top color="secondary">
            <template v-slot:activator="{ on }">
              <v-btn  class="mx-2" fab dark color="blue lighten-1" @click="newGroupPermission" v-on="on">
                <v-icon dark>add</v-icon>
              </v-btn>
            </template>
            <span>Create a new Goup Permission</span>
          </v-tooltip>
        </v-col>
      </v-row>

    </v-container>
    <v-data-table
      :search="search"
      :headers="headers"
      :items="renderedPermissionGroup"
      :loading="loading"
    >
      <template v-slot:item="props">
        <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
          <td v-if="header.text !== 'Actions'" style="text-align: center" v-for="(header, index) in headers" :key="index">
            {{props.item[header.value]}}
          </td>
          <td v-else style="text-align: center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-icon  color="green" @click="linkPermissions(props.item) " v-on="on">
                  enhanced_encryption
                </v-icon>
              </template>
              <span>link permissions</span>
            </v-tooltip>
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-icon  color="blue" @click="addOrRemove(props.item) " v-on="on">
                  people
                </v-icon>
              </template>
              <span>add or remove</span>
            </v-tooltip>
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-icon color="amber darken-2" @click="showAuditLog(props.item)" v-on="on">
                  history
                </v-icon>
              </template>
              <span>audit log</span>
            </v-tooltip>
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-icon  color="blue" @click="editRow(props.item) " v-on="on">
                  edit
                </v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-icon color="red" @click="deleteRow(props.item)" v-on="on" class="pl-1">
                  delete
                </v-icon>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog width="600px" v-model="newGoupPermissionDialog">
      <v-form v-model="valid" ref="formUser">
        <v-card :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
          <v-card-title >
            <h2>{{editedIndex === -1 ? 'New Group Permissions' : 'Edit Group Permissions'}}</h2>
            <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="newGoupPermissionDialog=false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider color="#42a5f5"></v-divider>
          <v-card-text>
            <v-container container--fluid grid-list-md>
              <v-row dense>
                <v-text-field
                  label="Name"
                  v-model="name"
                  :rules="nameRule"
                ></v-text-field>
              </v-row>
              <v-row dense>
                <v-text-field
                  label="Description"
                  v-model="description"
                ></v-text-field>
              </v-row>
              <v-row dense>
                <v-select
                  label="Choose a type..."
                  :items="types"
                  v-model="type"
                ></v-select>
              </v-row>
            </v-container>
          </v-card-text>
          <v-container container--fluid grid-list-xl px-6>
              <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                <v-col cols="12" md="3" class="text-center">
                  <v-btn
                    text
                    @click="close()"
                    color="blue-grey lighten-2"
                  >Cancel
                  </v-btn>
                </v-col>
                <v-col cols="12" md="3" class="text-center">
                  <v-btn
                    text
                    @click="toggleSave"
                    color="blue darken-1"
                  >Save
                  </v-btn>
                </v-col>
              </v-row>
          </v-container>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="addPermissionDialog" width="1400px">
        <v-card >
        <v-card-title>
          <h2>{{'Add Permission In Group ID ' + selectGroupId}}</h2>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="closePermisionsShow">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text>
                  <v-row :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'space-between'">
                    <v-col cols="12" sm="5" md="3">
                      <v-text-field label="Search..." v-model="searchPermission" prepend-icon="search"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="5" md="3">
                      <v-autocomplete
                        label="Choose a Permission..."
                        :items="renderedAllPermission"
                        item-text="name"
                        return-object
                        v-model="selectPermission"
                        prepend-icon="fas fa-map"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="5" md="3">
                      <v-tooltip top color="secondary">
                        <template v-slot:activator="{ on }">
                          <v-btn class="mx-2" fab dark color="blue lighten-1" @click="tickPermission" v-on="on">
                            <v-icon dark>add</v-icon>
                          </v-btn>
                        </template>
                        <span>Add Permission In Goup</span>
                      </v-tooltip>

                    </v-col>
                  </v-row>
                  <v-data-table
                    :search="searchPermission"
                    :headers="headersPermission"
                    :items="renderedPermissionInGroup"
                    item-key="name"
                    class="elevation-1"
                  >
                  <template v-slot:item="props">
                    <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
                      <td v-if="header.text !== 'Actions'" style="text-align: center" v-for="(header, index) in headersPermission" :key="index">
                        {{props.item[header.value]}}
                      </td>
                      <td v-else style="text-align: center">
                        <v-tooltip top color="secondary">
                          <template v-slot:activator="{ on }">
                            <v-icon large color="red" @click="removePermission(props.item)" v-on="on" class="pl-1">
                              remove
                            </v-icon>
                          </template>
                          <span>remove permissions</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                  </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="blue-grey lighten-2" @click="closePermisionsShow">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <AddUserPermissionGroup
      :selectGroupId="selectGroupId"
      :userPermisionShow="userPermisionShow"
      @close="closeUserPermisionShow"
    ></AddUserPermissionGroup>

    <v-dialog v-model="auditLogDialog" width="1200px">
      <v-card>
        <v-card-title>
          <h2>{{'Audit Log - Group ID ' + auditLogGroupId}}</h2>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="closeAuditLog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text>
          <v-data-table
            :headers="headersAuditLog"
            :items="auditLogData"
            :loading="auditLogLoading"
          >
            <template v-slot:item="props">
              <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
                <td style="text-align: center" v-for="(header, index) in headersAuditLog" :key="index">
                  {{props.item[header.value]}}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          You are about to delete this permission group. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>
          <v-btn text @click="toggleDelete" color="blue darken-1">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import AddUserPermissionGroup from "../../util/PermissionManage/AddUserPermissionGroup";

export default {
  name: "PermissionsManage",
  components: {
    AddUserPermissionGroup,
  },
  data(){
    return{
      newGoupPermissionDialog:false,
      search: null,
      reload: false,
      isVisible: false,
      timer: '',
      loading: false,
      valid:false,
      editedIndex: -1,
      headers:[
        {text: 'Name', value: 'name', align: 'center', sortable: true},
        {text: 'Description', value: 'description', align: 'center', sortable: true},
        {text: 'Type', value: 'type_text', align: 'center', sortable: true},
        {text: 'Actions', value: 'actions', align: 'center', sortable: false}
      ],
      headersPermission:[
        {text: 'Permissions Name', value: 'name', align: 'center', sortable: true},
        {text: 'Display', value: 'display', align: 'center', sortable: true},
        {text: 'Details', value: 'details', align: 'center', sortable: true},
        {text: 'Actions', value: 'actions', align: 'left', sortable: false},
      ],
      name: null,
      description:null,
      type:null,
      permissionGroupnID:null,
      nameRule: [
        v => !!v || 'This field is required'
      ],
      typeRule:[
        v => !!v || 'This field is required',
        v => /^[0-9]*$/.test(v) || 'type must be valid'
      ],
      toBeDeleted:null,
      deleteDialog: false,
      userPermisionShow:false,
      searchPermission:null,
      selectGroupId:null,
      addPermissionDialog:false,
      permission: null,
      selectPermission:null,
      auditLogDialog:false,
      auditLogGroupId:null,
      auditLogData:[],
      auditLogLoading:false,
      headersAuditLog:[
        {text: 'Action', value: 'action', align: 'center', sortable: true},
        {text: 'User', value: 'user_name', align: 'center', sortable: true},
        {text: 'Region', value: 'region_name', align: 'center', sortable: true},
        {text: 'Performed By', value: 'performed_by_name', align: 'center', sortable: true},
        {text: 'Date', value: 'created_at', align: 'center', sortable: true},
      ],
      types:[
        {text: "General", value: 0},
        {text: "Client Only", value: 1},
        {text: "Internal Only", value: 2},
        {text: "HF Only", value:3}
      ],
    }
  },
  mounted: function () {
    this.timer = setInterval(() => {
      this.reload = !this.reload;
    }, 300000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods:{
    editRow(item){
      this.valid = true;
      this.permissionGroupnID = item['id'];
      this.name = item['name'];
      this.description = item['description'];
      this.type = item['type'];
      this.editedIndex = 1;
      this.newGoupPermissionDialog = true;
    },
    newGroupPermission(){
      this.editedIndex = -1;
      this.name = null;
      this.description = null;
      this.type = null;
      this.newGoupPermissionDialog = true;
      this.valid = false
    },
    close() {
      this.editedIndex = -1;
      this.newGoupPermissionDialog = false;
      this.valid = false
    },
    deleteRow(item){
      this.toBeDeleted = item;
      this.deleteDialog = true;
    },
    toggleDelete(){
      axios.delete(process.env.API_URL + '/permissiongroups/' + this.toBeDeleted.id)
        .then((response) => {
          this.toBeDeleted = null;
          this.updateDataTable();
          this.$store.commit('displaySnackbar', 'Delete successful');
        })
        .catch((error) => {
          this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
        });
      this.deleteDialog = false;
    },
    toggleSave(){
      let body = {};
      body = {
        name:this.name,
        description:this.description,
        destination_depot:this.destinationDepot,
        type:this.type,
      };
      if(!this.validationInput(body)){
        return false;
      };
      if(this.editedIndex < 0){
        axios.post(process.env.API_URL + '/permissiongroups', body)
          .then((response) => {
            this.updateDataTable();
            this.$store.commit('displaySnackbar', 'Create successful');
          })
          .catch((error) => {
            this.$store.commit('displaySnackbar', 'Error: ' + error.response ? error.response.data.error : error);
          });

      } else {
        //update
        axios.post(process.env.API_URL + '/permissiongroups/'+ this.permissionGroupnID, body)
          .then((response) => {
            this.updateDataTable();
            this.$store.commit('displaySnackbar', 'Update successful');
          })
          .catch((error) => {
            this.$store.commit('displaySnackbar', 'Error: ' + error.response ? error.response.data.error : error);
          });
        this.permissionGroupnID = null;
      }
      this.newGoupPermissionDialog = false;
    },
    validationInput(body){
      if (body.name === null) {
        this.$store.commit('displaySnackbar', 'Please input name');
        return false;
      } else if (body.type === null) {
        this.$store.commit('displaySnackbar', 'Please input type');
        return false;
      } else {
        return true;
      }
    },
    updateDataTable() {
      this.reload = !this.reload;
    },
    refresh() {
      setTimeout(() => this.isVisible = false, 1000);
      this.isVisible = true;
      this.reload = !this.reload;
    },
    addOrRemove(item){
      this.selectGroupId = item.id;
      this.userPermisionShow = true;
    },
    closeUserPermisionShow(){
      this.userPermisionShow = false;
      this.selectGroupId = null;
    },
    tickPermission(){
      if(this.selectPermission === null){
        this.$store.commit('displaySnackbar', 'Please select Permission');
        return false;
      }
      let body ={};
      body = {
        permission_id:this.selectPermission.id,
      };
      axios.post(process.env.API_URL + '/permissiongroups/' + this.selectGroupId + '/permissions/' + this.selectPermission.id,body)
        .then((response) => {
          this.updateDataTable();
          this.$store.commit('displaySnackbar', 'Update successful');
        })
        .catch((error) => {
          this.$store.commit('displaySnackbar', 'ERROR: ' + (error.response.data === undefined ? 'Undefined' : error.response.data.error));
        });
        this.selectPermission = null;
    },
    linkPermissions(item){
      this.selectGroupId = item.id;
      this.addPermissionDialog = true;
    },
    closePermisionsShow(){
      this.addPermissionDialog = false;
      this.selectGroupId = null;
    },
    removePermission(item){
      if(item.id === null  || item.id === undefined){
        this.$store.commit('displaySnackbar', 'Please select Permission');
        return false;
      }
      axios.delete(process.env.API_URL + '/permissiongroups/' + this.selectGroupId + '/permissions/' + item.id)
        .then((response) => {
          this.updateDataTable();
          this.$store.commit('displaySnackbar', 'Update successful');
        })
        .catch((error) => {
          this.$store.commit('displaySnackbar', 'ERROR: ' + (error.response === undefined ? 'Undefined' : error.response.data.error));
        });

    },
    showAuditLog(item){
      this.auditLogGroupId = item.id;
      this.auditLogDialog = true;
      this.fetchAuditLog();
    },
    fetchAuditLog(){
      this.auditLogLoading = true;
      axios.get(process.env.API_URL + '/permissiongroups/' + this.auditLogGroupId + '/auditlog')
        .then((response) => {
          this.auditLogLoading = false;
          this.auditLogData = response.data;
        })
        .catch((error) => {
          this.auditLogLoading = false;
          this.auditLogData = [];
          this.$store.commit('displaySnackbar', 'ERROR: Failed to load audit log');
        });
    },
    closeAuditLog(){
      this.auditLogDialog = false;
      this.auditLogGroupId = null;
      this.auditLogData = [];
    }
  },
  computed: {
    renderedPermissionGroup() {
      if (this.permissionGroup === null || this.permissionGroup === undefined) {
        return [];
      } else {
        return this.permissionGroup;
      }
    },
    renderedAllPermission() {
      if (this.allPermissions === null || this.allPermissions === undefined) {
        return [];
      } else {
        return this.allPermissions;
      }
    },
    renderedPermissionInGroup() {
      if (this.permissionsInGroup === null || this.permissionsInGroup === undefined) {
        return [];
      } else {
        return this.permissionsInGroup;
      }
    }
  },
  asyncComputed: {
    async permissionGroup() {
      if (this.reload || !this.reload) {
        this.loading = true;
        return await axios.get(process.env.API_URL + '/permissiongroups')
          .then((response) => {
            if (response.status === 200) {
              this.loading = false;
              return response.data;
            } else {
              this.loading = false;
              return [];
            }
          })
          .catch((error) => {
            this.loading = false;
            return [];
          });
      }
    },
    async permissionsInGroup() {
      if(this.selectGroupId !== null ){
        if (this.reload || !this.reload) {
          this.loading = true;
          return await axios.get(process.env.API_URL + '/permissiongroups/' + this.selectGroupId + '/permissions')
            .then((response) => {
              if (response.status === 200) {
                this.loading = false;
                return response.data;
              } else {
                this.loading = false;
                return [];
              }
            })
            .catch((error) => {
              this.loading = false;
              return [];
            });
        }
      }
    },
    async allPermissions(){
      if (this.reload || !this.reload) {
        this.loading = true;
        return axios.get(process.env.API_URL + '/users/permissions')
          .then((response) => {
            this.loading = false;
            return response.data;
          }).catch((response) => {
            this.loading = false;
            return [];
          });
      }
    },
  }
}
</script>

<style scoped>

>>>.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev {
  display: none!important;
}

.line {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 15px;
  background-color: #6754a8;
}

@keyframes loadingC {
0 {transform: translate(0,0);}
50% {transform: translate(0,15px);}
100% {transform: translate(0,0);}
}

.load-3 .line:nth-last-child(1) {animation: loadingC .6s .1s linear infinite;}
.load-3 .line:nth-last-child(2) {animation: loadingC .6s .2s linear infinite;}
.load-3 .line:nth-last-child(3) {animation: loadingC .6s .3s linear infinite;}


</style>



// WEBPACK FOOTER //
// src/components/pages/Manage/PermissionsManage.vue